<template>
    <rkm-area title="Serviço de enfermagem">
        <template slot="trailing">
            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                v-rkm-tooltip.hover
                title="Adicionar serviço de enfermagem"
                small
            >
                <rkm-icon icon="plus" />
            </rkm-button>
        </template>

        <List
            :data="data"
        />

        <rkm-row>
            <rkm-col>
                <rkm-form-incremental-textarea
                    readonly
                    :items="data.form.atendimentoMedico.observacoesEnfermagem"
                    label="Observações de Serviços de Enfermagem"
                >
                    <template v-slot:row="{ item }">
                        <rkm-row>
                            <rkm-col cols="4">
                                <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                <div>{{ item.lotacao.profissional.nome }}</div>
                                <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                                <div>{{ item.dataHora }}</div>
                            </rkm-col>

                            <rkm-col>
                                {{ item.descricao }}
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-form-incremental-textarea>
            </rkm-col>
        </rkm-row>

        <Modal
            :data="data"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'
import RkmFormIncrementalTextarea from '@/components/pronto-atendimento/components/base/FormIncrementalTextarea'

export default {
    components: { List, Modal, RkmFormIncrementalTextarea },
    props: {
        data: { type: Object, required: true },
    },
}
</script>